// src/App.jsx
import React, { useState, useEffect } from "react";
import { createAuthClient } from "./api/auth";
import Icon from "./components/Icon";
import Topbar from "./components/Topbar";
import Sidebar from "./components/Sidebar";
import LoginPage from "./components/LoginPage";
import Dashboard from "./components/Dashboard";
import AnggotaPage from "./components/Anggota";
import SimpananPage from "./components/Simpanan";
import PinjamanPage from "./components/Pinjaman";
import Transaction from "./components/Transaction";
import Report from "./components/Report";
import PengaturanPage from "./components/Pengaturan";

export default function App() {
  const [auth, setAuth] = useState(() => {
    try {
      const saved = localStorage.getItem("auth");
      return saved ? JSON.parse(saved) : null;
    } catch {
      return null;
    }
  });
  const [active, setActive] = useState("Dashboard");
  const [initialLoanId, setInitialLoanId] = useState(null);

  const roleMenus = {
    administrator: [
      "Dashboard",
      "Anggota",
      "Transaksi",
      "Pinjaman",
      "Simpanan",
      "Laporan",
      "Pengaturan",
    ],
    pegawai: [
      "Anggota",
      "Transaksi",
      "Pengaturan",
    ],
    anggota: [
      "Dashboard",
      "Transaksi",
      "Pinjaman",
      "Simpanan",
      "Pengaturan",
    ],
  };

  const userRole = auth?.user?.role || "anggota";
  const allowedKeys = roleMenus[userRole] || ["Transaksi"];

  const allMenuItems = [
    { key: "Dashboard", label: "Dashboard", icon: "dashboard" },
    { key: "Anggota", label: "Anggota", icon: "users" },
    { key: "Transaksi", label: "Transaksi", icon: "history" },
    { key: "Pinjaman", label: "Pinjaman", icon: "loan" },
    { key: "Simpanan", label: "Simpanan", icon: "wallet" },
    { key: "Laporan", label: "Laporan", icon: "report" },
    { key: "Pengaturan", label: "Pengaturan", icon: "settings" },
  ];

  const sidebarItems = allMenuItems.filter((item) =>
    allowedKeys.includes(item.key)
  );

  useEffect(() => {
    if (!allowedKeys.includes(active)) {
      setActive(allowedKeys[0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userRole]);

  const handleLogout = () => {
    localStorage.removeItem("auth");
    setAuth(null);
    setActive("Dashboard");
  };

  // onNavigate sekarang terima 2 parameter: page dan opsional loanId
  const handleNavigate = (page, loanId = null) => {
    setInitialLoanId(loanId);
    setActive(page);
  };

  if (!auth) {
    return <LoginPage onLogin={setAuth} />;
  }

  const api = createAuthClient(auth.token, handleLogout);

  return (
    <div className="min-h-screen bg-slate-50 text-slate-800">
      <Topbar auth={auth} handleLogout={handleLogout} />
      <div className="max-w-7xl mx-auto px-4 py-6 grid grid-cols-12 gap-4">
        <Sidebar
          items={sidebarItems}
          active={active}
          onChange={(page) => handleNavigate(page)}
        />
        <main className="col-span-12 md:col-span-9 lg:col-span-10 space-y-6">
          {active === "Dashboard" && (
            <Dashboard
              Icon={Icon}
              api={api}
              auth={auth}
              onNavigate={handleNavigate}
            />
          )}
          {active === "Anggota" && <AnggotaPage api={api} />}
          {active === "Transaksi" && <Transaction api={api} />}
          {active === "Pinjaman" && (
            <PinjamanPage
              api={api}
              auth={auth}
              initialLoanId={initialLoanId}
              onClearInitialLoan={() => setInitialLoanId(null)}
            />
          )}
          {active === "Simpanan" && <SimpananPage api={api} auth={auth} />}
          {active === "Laporan" && <Report api={api} />}
          {active === "Pengaturan" && <PengaturanPage api={api} auth={auth} />}
        </main>
      </div>
      <footer className="py-8 text-center text-sm text-slate-500">
        © 2025 PT.Crown Worldwide Indonesia — Mockup UI (Web-based)
      </footer>
    </div>
  );
}